<template>
  <div class="chatwoot-container">
    <div class="profile-links">
      <router-link
        v-if="showUserProfile"
        class="profile-link"
        :to="{ name: 'profile.my-profile' }"
      >
        User Profile
      </router-link>
      <router-link
        v-if="showBabysitterProfile"
        class="profile-link"
        :to="{ name: 'profile-babysitter' }"
      >
        Babysitter Profile
      </router-link>
      <router-link
        v-if="showFamilyProfile"
        class="profile-link"
        :to="{ name: 'profile-family' }"
      >
        Family Profile
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Chatwoot',
  data() {
    return {
      showUserProfile: false,
      showBabysitterProfile: false,
      showFamilyProfile: false,
    };
  },
  mounted() {
    window.addEventListener('message', (event) => {
      console.log(event);
      if (!this.isJSONValid(event.data)) {
        return;
      }
      const eventData = JSON.parse(event.data);
      console.log(eventData);

      if (eventData.contact?.custom_attributes) {
        const attrs = eventData.contact.custom_attributes;
        this.showUserProfile = true; // Always show user profile option
        this.showBabysitterProfile = !!attrs.babysitter_profile;
        this.showFamilyProfile = !!attrs.family_profile;
      }
    });
  },
  methods: {
    isJSONValid(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.profile-links {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.profile-link {
  padding: 0.5rem 1rem;
  background-color: #4caf50;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
}

.profile-link:hover {
  background-color: #45a049;
}
</style>
